// src/lib/standortScore.ts
// Konsolidiert die zuvor dreifach byte-identisch duplizierte calcScore()-Logik
// (src/routes/StandortScore.tsx und src/hooks/useStandort.ts) an einer Stelle.
// Reine Funktionen, keine Aenderung an Formel oder Anzeige -- der bestehende
// Standort-Score (StandortPanel, /standort) bleibt exakt wie er war.
//
// WICHTIG: Das ist NICHT der neue Deal-Score (src/core/score/dealScore.ts) --
// der nutzt die Lage-Rohdaten (r, Perzentil von k) direkt, nicht diesen Score.

export type StandortScoreLabel = "attraktiv" | "durchschnitt" | "schwach";

export function calcStandortScore(k: number, m: number, r: number): { score: number; label: StandortScoreLabel; color: string } {
  // Rendite: 0-10 Punkte (4% = 5, 6% = 10)
  const renditeScore = Math.min(10, Math.max(0, (r - 0.02) / 0.04 * 10));
  // Kaufpreis-Faktor: niedriger = besser (unter 25 = gut, ueber 35 = schlecht)
  const faktor = k / (m * 12);
  const faktorScore = Math.min(10, Math.max(0, (35 - faktor) / 10 * 10));
  // Mietpreis absolut (7€ = mittel, 14€+ = teuer -> weniger Rendite, aber Nachfrage)
  const nachfrageScore = Math.min(10, Math.max(0, (m - 5) / 10 * 10));

  const total = renditeScore * 0.5 + faktorScore * 0.3 + nachfrageScore * 0.2;
  const score = Math.round(total * 10);

  const label: StandortScoreLabel = score >= 70 ? "attraktiv" : score >= 45 ? "durchschnitt" : "schwach";
  const color = score >= 70 ? "#4ade80" : score >= 45 ? "#FCDC45" : "#f87171";
  return { score, label, color };
}

/**
 * Perzentil von k ueber eine sortierte Liste aller Kaufpreise (Anteil der PLZ mit
 * kleinerem oder gleichem k, in Prozent). Fuer die Lage-Komponente des Deal-Score
 * (nicht fuer calcStandortScore() oben).
 */
export function percentileOfK(sortedKs: readonly number[], k: number): number {
  if (sortedKs.length === 0) return 0;
  let count = 0;
  for (const v of sortedKs) if (v <= k) count++;
  return (count / sortedKs.length) * 100;
}
